import React, { Fragment, useEffect } from "react";
import { IconButton, styled } from "@material-ui/core";
import {
  DollarIcon,
} from "../../GlobalAddDealModalV3/components/Icons";
import HeaderSearchBarInsurance from "./HeaderSearchBarInsurance";
import Utils from "../../../helpers/Utils";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentCredit } from "../../../actions/globalDialerAction";
import { useHistory } from "react-router-dom";
import HeaderAddPopover from "./HeaderAddPopover";
import HeaderProfilePopover from "./HeaderProfilePopover";
import HeaderNotificationPopover from "./HeaderNotificationPopover";
import { fetchNotificationCount } from "../../../actions/notificationAction";
import { CODE_SNIPPET } from "../../../constants/CoreConstants";
import { Userpilot } from "userpilot";
import HeaderGlobalDialerInsurance from "./HeaderGlobalDialerInsurance";
import HeaderInsuranceLoginToParent from "./HeaderInsuranceLoginToParent";
import { HEADER_COLORS } from "./constants";
import { AGENCY_BUSINESS_TYPE } from "../../../helpers/CoreConstant";
import moment from "moment";
import { useState } from "react";
import TrainingVideoModal from "../../common/TrainingVideoModal";

const HeaderWrapper = styled("header")(({ theme, menuCollapsed, minimizedLogo, insuranceAgency }) => ({
  height: 80,
  backgroundColor: "var(--topbar-background)",

  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: insuranceAgency ? (menuCollapsed && minimizedLogo ? '24px 24px 24px 14px' : '24px 24px 24px 35px') : 24,

  "& .leftSideWrapper": {
    height: "100%",
    width: "fit-content",

    display: "flex",
    alignItems: "center",
    gap: 30,

    boxSizing: "content-box",
    transition: "all 0.5s ease-in-out",

    "& .toggleCollapse": {
      cursor: "pointer",
    },

    "& .logo": {
      maxWidth: 151,
      maxHeight: 55,
      objectFit: "cover",
    },
  },

  "& .rightSideWrapper": {
    width: "100%",
    height: "100%",

    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 8,

    "& .actionButton": {
      border: "1.8px solid #e0e0e0",
      backgroundColor: "#ffffff",
      borderRadius: 12,
      padding: "12px !important",
      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1) !important",
      "&:focus, &:hover": {
        backgroundColor: "#f4f5f6",
      },

      "& .balance": {
        display: "flex",
        alignItems: "center",
        gap: 8,

        "& .balanceAmount": {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: "20px",
          color: "#58cc8a",
          margin: 0,
        },
      },

      "&.profile": {
        padding: "4px 8px !important",

        "& .profileWrapper": {
          display: "flex",
          alignItems: "center",
          gap: 8,
        },

        "& .avatarImgWrapper": {
          display: "flex",
          "& .avatarImg": {
            width: 32,
            height: 32,
            objectFit: "cover",
            borderRadius: "50%",
          },

          "& .MuiAvatar-colorDefault": {
            backgroundColor: "#bdbdbd"
          }
        },

        "& .userInfo": {
          "& .title": {
            color: "#36454F",
            fontSize: 14,
            fontWeight: 600,
            lineHeight: "20px",

            textAlign: "left",
            margin: 0,
          },
          "& .email": {
            color: "#36454F",
            fontSize: 12,
            fontWeight: 400,
            lineHeight: "16px",

            textAlign: "left",
            margin: 0,
          },
        },
      },
    },
    "& .actionButtonTimer": {
      border: '1.8px solid rgb(224, 224, 224)',
      borderRadius: '12px',
      backgroundColor: 'rgb(255, 255, 255)',
      padding: '6px 8px',
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px',
      marginRight: '8px',
      "&:focus, &:hover": {
        backgroundColor: "#f4f5f6",
      },
    },
    "& .callEndSection": {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '80px'
    },
    "& .svgContainer": {
      backgroundColor: 'var(--red)',
      width: '30px',
      height: '30px',
      borderRadius: '50%'
    }
  },
}));

const HeaderInsurance = ({ menuCollapsed, minimizedLogo, agencyLogo, avatar, userEmail, userName }) => {
  const insuranceAgency =
    Utils.getAccountData("agencyBusinessType") ===
    AGENCY_BUSINESS_TYPE.INSURANCE;
  const dispatch = useDispatch();
  const history = useHistory();
  const { currentCredit } = useSelector((state) => state.globalDialerReducer);
  // State for video modal
  const [modalOpen, setModalOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState(null);
  const [moduleId, setModuleId] = useState(null); // New state for dynamic moduleId

  // Video mapping based on flag (customize this)
  const videoMap = {
    STEP_SELECT_COMPANY:
      "https://www.loom.com/embed/0fc5a06f29d247538a84aaa3eb5a575f?sid=0d1eae1b-85c8-4b61-8766-bfbd666b41ab",
    STEP_SET_SALES_GOAL:
      "https://www.loom.com/embed/a97cdd8eda1745818f35afb1989812bc?sid=fa0420e8-1c44-4f12-ba74-944adb3f09f0",
    STEP_SELECT_PRODUCT:
      "https://www.loom.com/embed/76405d3bc1414047a838a7ad8e543448?sid=657528ce-25e5-4dc6-92c3-c7a512733d2f",
    STEP_CREATE_CONTACT:
      "https://www.loom.com/embed/82b17d819bac44a8b6186ab397402dcb?sid=d07ef049-bd24-428e-ab92-d2745ab6951c",
    STEP_IMPORT_CONTACT:
      "https://www.loom.com/embed/8319627b151f46b386caec05d4404680?sid=184bd20a-6daf-454b-aec4-0be339e2f609",
    STEP_CONNECT_EMAIL:
      "https://www.loom.com/embed/5d041c03329b4299bda1f610414ffc8e?sid=45a39f9c-938a-48ff-bd3d-33e5fe5ba525",
    STEP_GET_VIRTUAL_NUMBER:
      "https://www.loom.com/embed/cc1d847059424007a8f616282c073ced?sid=9c92b6ea-cfcc-4647-bdcc-fb4fed1614a7",
    STEP_ADD_TEAM_MEMBER:
      "https://www.loom.com/embed/70a57f8da9434e70b0c4e8f637619fa0?sid=d08d88d4-66b2-440f-b630-53baa9773d59",
  };

  useEffect(() => {
    dispatch(getCurrentCredit());
    dispatch(fetchNotificationCount({}));

    Utils.loadSocket(Utils.getAccountData("userId"));
    if (process.env.NODE_ENV !== "development") {
      let agencyId = Utils.getAccountData("agencyId");
      let fullName = Utils.getAccountData("fullName");
      let dateStr = Utils.getAccountData("createdAt");
      if (agencyId == 236) {
        if (dateStr) {
          try {
            dateStr = dateStr.date;
            dateStr = dateStr.split(".")[0] + "Z";
            dateStr = window.globalTimezoneConversionToDifferentTimezone(
              dateStr,
              "UTC"
            );
            dateStr = Math.floor(new Date(dateStr).getTime() / 1000);
          } catch (e) {
            dateStr = Math.floor(Date.now() / 1000);
          }
        }
      }
      Utils.loadCodeSnippets(CODE_SNIPPET.AFTER_LOGIN, {
        agencyId: agencyId,
        userId: Utils.getAccountData("userId"),
        email: Utils.getAccountData("email"),
        fullName: fullName,
        createdAt: dateStr,
      });
    }

    if (Utils.getAccountData("agencyId") === 1) {
      Userpilot.identify(Utils.getAccountData("userId"), {
        name: Utils.getAccountData("fullName"),
        email: Utils.getAccountData("email"),
      });
    }
    const urlParams = new URLSearchParams(window.location.search);
    const flag = urlParams.get("flag");
    if (flag && videoMap[flag]) {
      setVideoSrc(videoMap[flag]);
      setModuleId(`header_training_${flag}`);
      setModalOpen(true);
    }
  }, []);

  window.updateCurrentCredit = () => {
    dispatch(getCurrentCredit());
  };
  const handleCloseModal = () => {
    setModalOpen(false);
    setVideoSrc(null);
    setModuleId(null);
    const url = new URL(window.location);
    url.searchParams.delete("flag");
    window.history.replaceState({}, document.title, url);
  };
  return (
    <HeaderWrapper
      className="insuranceHeader"
      menuCollapsed={menuCollapsed}
      minimizedLogo={minimizedLogo}
      insuranceAgency={insuranceAgency}
    >
      <div className="leftSideWrapper">
        <img
          className="logo"
          src={menuCollapsed && minimizedLogo ? minimizedLogo : agencyLogo}
          alt="logo"
        />
      </div>
      <div style={{ width: "900px", marginLeft: "27px", marginRight: "10px" }}>
        {!Utils.getAccountData("isTemplateUser") &&
          !Utils.getAccountData("userOnboard") && <HeaderSearchBarInsurance />}
      </div>

      <div className="rightSideWrapper">
        <HeaderInsuranceLoginToParent />
        {!Utils.getAccountData("userOnboard") && (
          <Fragment>
            <HeaderGlobalDialerInsurance />
            <HeaderAddPopover />
            <HeaderNotificationPopover />
          </Fragment>
        )}

        {Utils.getAccountData("userIsOwner") &&
          !Utils.getAccountData("userOnboard") && (
            <IconButton
              className="actionButton"
              onClick={() => {
                if (window.location.pathname !== "/billing")
                  history.push("/billing");
              }}
            >
              <div className="balance">
                <DollarIcon color={HEADER_COLORS.DOLLER_ICON} />
                {/*Dollar icon color green*/}
                <p className="balanceAmount">
                  {currentCredit === undefined
                    ? "..."
                    : Number(currentCredit).toFixed(2)}
                </p>
              </div>
            </IconButton>
          )}
        <HeaderProfilePopover
          avatar={avatar}
          userEmail={userEmail}
          userName={userName}
        />
      </div>
      <TrainingVideoModal
        open={modalOpen}
        onClose={handleCloseModal}
        videoSrc={
          videoSrc ||
          "https://cdn.pixabay.com/video/2020/06/22/42890-432450896_large.mp4"
        } // Fallback video
        moduleId={moduleId || "header_training_default"} // Use dynamic moduleId or fallback
      />
    </HeaderWrapper>
  );
};

export default HeaderInsurance;
